import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import Avatar from "../../../../../core/Avatar/Avatar";
function BalanceMobile() {
    const {t} = useTranslation()
    const {balance, currency, avatar} = useSelector(state => state.user);
    return (
        <div className="mobile-header-balance">
            <div className="mobile-header-balance-avatar">
                <Avatar externalAvatarIndex={avatar} />
            </div>
            <div className="mobile-header-balance-wrapper">
                <h1>{t('balance')}</h1>
                <span>{`${balance} ${currency}`}</span>
            </div>
        </div>
    )
}
export default BalanceMobile